module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMlJREFUKBWV0TEKAjEQBdCZuO4BPIWttYUIuiDYWXsDxbOIlYVHsBMEERYLa2/iAUQT8yORNW4mGghp5r+ZJESJNT+NOtiJMmKpwAH3x9HVZI3Bqre/xOqjkEcMmRbCTHwlAauFqogFboAsmEvYFxQiStEEkNa0lbAPqA5Z9g87QIuyGEvYG5IQQFgS5qBfkBcVx3hWFm3WdMbv4GHxJv46Phye4WRGUVexMdN/EKBohIZo7LLWUFkz3zDzWhENU5NUJ3OYzSAL4wnGs5aSOOIAfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/path.png
// module id = F849
// module chunks = 0